import { render, staticRenderFns } from "./importDataLiles.vue?vue&type=template&id=cfb5988c&scoped=true"
import script from "./importDataLiles.vue?vue&type=script&lang=js"
export * from "./importDataLiles.vue?vue&type=script&lang=js"
import style0 from "./importDataLiles.vue?vue&type=style&index=0&id=cfb5988c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb5988c",
  null
  
)

export default component.exports